export default {
  'Choose File': '파일  선택',
  'Please paste a URL': 'URL을 붙여넣으십시오.',
  'Loading': '로딩 중',
  'Analyzing': '해석중입니다.',
  'Try a sample': '샘플을 사용해 보십시오.',
  'Sorry, error occurs when analyzing the URL.': '죄송합니다. URL을 분석할 때 오류가 발생합니다.',
  'Upload a photo': '사진 업로드',
  "Drag and drop files to the upload box.": '파일을 업로드 박스로 끌어다 놓습니다.',
  'Please select the proper position with portrait.': '초상화를 사용하여 적절한 위치를 선택하십시오.',
  'downloading': '다운로드 중',

}